import type { ConsoleCatalog } from "./en";

/** نصوص وحدة إدارة المنصة (النطاق `console`). */
const ar: ConsoleCatalog = {
  nav: {
    overview: "نظرة عامة",
    organisation: "الجهات والصلاحيات",
    lifecycle: "دورة السياسات والذكاء الاصطناعي",
    content: "المحتوى والمعايير",
    assurance: "الضمان والرقابة",
    tenants: "الجهات والهوية البصرية",
    identity: "المستخدمون والهوية",
    roles: "الأدوار والصلاحيات",
    workflows: "استوديو مسارات العمل",
    agents: "استوديو الوكلاء",
    prompts: "مكتبة التعليمات",
    toolkit: "الأدوات والمخططات",
    templates: "قوالب الوثائق",
    conformance: "سجل المطابقة",
    knowledge: "مكتبة المعرفة",
    aiGovernance: "حوكمة الذكاء الاصطناعي",
    audit: "التدقيق والأمن",
    releases: "الإصدارات",
    backoffice: "فتح منصة السياسات الوطنية الذكية",
  },
  noAccess: "لا يتضمن دورك صلاحية الوصول إلى وحدة إدارة المنصة. يُرجى تسجيل الدخول بحساب إدارة المنصة، أو العودة إلى منصة السياسات الوطنية الذكية.",
  pages: {
    overview: { title: "وحدة إدارة المنصة", description: "إعداد منصة السياسات الوطنية الذكية وضمان سلامتها.", empty: "اختر مجالاً لإدارته", emptyBody: "استخدم القائمة لإعداد الجهات والهوية ومسارات العمل والوكلاء ومعايير المحتوى وحوكمة الذكاء الاصطناعي." },
    tenants: { title: "الجهات والهوية البصرية", description: "الوزارات والأمانة العامة لمجلس الوزراء وجهة المنصة، مع هويتها البصرية ونطاقاتها وحالتها.", empty: "لا توجد جهات للعرض", emptyBody: "أنشئ مساحة عمل لوزارة لإضافة جهة جديدة." },
    identity: { title: "المستخدمون والهوية", description: "مستخدمو المنصة وحالاتهم، ومزوّدو الدخول الموحد: الهوية الرقمية (UAE PASS) وOpenID Connect.", empty: "لم يُعدّ أي مزوّد هوية", emptyBody: "اربط الهوية الرقمية (UAE PASS) أو مزوّد OpenID Connect لتفعيل الدخول الموحد." },
    roles: { title: "الأدوار والصلاحيات", description: "الأدوار المدمجة لكل نوع من مساحات العمل والصلاحيات التي تمنحها.", empty: "لا توجد أدوار", emptyBody: "تحدد المنصة الأدوار." },
    workflows: { title: "استوديو مسارات العمل", description: "قوالب دورة السياسات الوطنية: المراحل والبوابات والمدد المحددة والاعتمادات، بإصدارات تُنشر وفق مبدأ الاعتماد الثنائي.", empty: "لا توجد قوالب لدورة السياسات", emptyBody: "أنشئ قالباً وتحقق من صحته ثم انشره للوزارات." },
    agents: { title: "استوديو الوكلاء", description: "وكلاء البحث، وفئة الذكاء الاصطناعي والتعليمات والأدوات والحد الأعلى لتصنيف البيانات لكل منهم.", empty: "لم يُعدّ أي وكيل", emptyBody: "يُحمَّل الوكلاء من حزمة السجل." },
    prompts: { title: "مكتبة التعليمات", description: "إصدارات تعليمات الوكلاء والمهارات: قارن الإصدارات، وأعدّ إصداراً جديداً، وفعّله.", empty: "لا توجد تعليمات بعد", emptyBody: "تُحمَّل التعليمات من حزمة السجل وتُدار إصداراتها هنا." },
    toolkit: { title: "الأدوات والمخططات", description: "حزمة السجل المستخدمة، وأنواع السجلات وحقولها وقوائم القيم التي تعتمد عليها النماذج والوكلاء.", empty: "لا توجد أنواع سجلات", emptyBody: "تعذّرت قراءة سجل أنواع السجلات من الحزمة." },
    templates: { title: "قوالب الوثائق", description: "قوالب وثائق دليل إعداد السياسات العامة ومختبر التشريعات من حزمة السجل.", empty: "لا توجد قوالب", emptyBody: "لا يطابق أي قالب هذا الإطار." },
    conformance: { title: "سجل المطابقة", description: "جميع متطلبات دليل إعداد السياسات العامة ومختبر التشريعات، ومرحلة كل منها وبوابتها ومستواها وصياغتها المعتمدة." },
    knowledge: { title: "مكتبة المعرفة", description: "التشريعات والأدلة والاستراتيجيات التي يستشهد بها الوكلاء: المجموعات والوثائق واختبار الاسترجاع والمسرد." },
    aiGovernance: { title: "حوكمة الذكاء الاصطناعي", description: "استخدام الذكاء الاصطناعي وتكلفته، وأحداث الضوابط، ونتائج التقييم، وسجل المراجعة البشرية." },
    audit: { title: "التدقيق والأمن", description: "سجل التدقيق الكاشف للتلاعب في جميع مساحات العمل، والتحقق من سلسلة التجزئة، والتصدير.", empty: "لا توجد أحداث مطابقة", emptyBody: "غيّر عوامل التصفية أو النطاق الزمني." },
    releases: { title: "الإصدارات", description: "المنشور حالياً: إصدار وحدة الإدارة، وحزمة سجل واجهة برمجة التطبيقات، وحالة المنصة." },
  },
  table: { actions: "الإجراءات" },
  form: {
    required: "هذا الحقل مطلوب.",
    format: "الصيغة غير صحيحة.",
    email: "أدخل عنوان بريد إلكتروني صحيحاً.",
  },
  json: {
    notObject: "يجب أن تكون الوثيقة كائناً بصيغة JSON.",
    invalid: "صيغة JSON غير صحيحة: {{message}}",
    valid: "صيغة JSON صحيحة",
  },
  diff: {
    changes_one: "تغيّر سطر واحد",
    changes_other: "عدد الأسطر المتغيرة: {{count}}",
    identical: "الإصداران متطابقان.",
  },
  period: {
    label: "الفترة",
    days_one: "آخر يوم",
    days_other: "الأيام الـ{{count}} الأخيرة",
  },
  overview: {
    health: "حالة المنصة",
    dbUp: "قاعدة البيانات متاحة",
    dbDown: "قاعدة البيانات غير متاحة",
    checkedAt: "آخر فحص {{time}}",
    kpi: {
      tenants: "الجهات",
      users: "المستخدمون",
      policies: "السياسات",
      runsRunning: "تشغيلات الوكلاء الجارية",
      runsFailed: "تشغيلات الوكلاء المخفقة",
      outbox: "رسائل صادرة معلّقة",
      notifications: "إشعارات معلّقة",
      bridge: "دفعات الربط (24 ساعة)",
    },
    last24h: "آخر 24 ساعة",
    bridgeRejected_one: "دفعة واحدة مرفوضة",
    bridgeRejected_other: "المرفوض: {{count}}",
    tenantsTitle: "الجهات",
    tenantsBody: "مساحات العمل حسب النوع والحالة.",
    manageTenants: "إدارة الجهات",
    usageTitle: "استخدام الذكاء الاصطناعي",
    usageBody: "الاستدعاءات حسب الوكيل خلال الأيام الـ{{days}} الأخيرة.",
    openGovernance: "فتح حوكمة الذكاء الاصطناعي",
    areas: "مجالات وحدة الإدارة",
  },
  usage: {
    calls: "استدعاءات الذكاء الاصطناعي",
    cost: "التكلفة (بالدولار الأمريكي)",
    emptyTitle: "لا يوجد استخدام للذكاء الاصطناعي في هذه الفترة",
    emptyBody: "يظهر الاستخدام بعد تشغيل الوكلاء.",
    byTenant: "التكلفة حسب الجهة",
    byAgent: "حسب الوكيل",
    byClassification: "الاستدعاءات حسب التصنيف",
    byUser: "حسب الشخص",
    automated: "أعمال آلية",
    allWorkspaces: "جميع مساحات العمل",
    workspace: "مساحة العمل",
    computeShared: "تعمل مساحة العمل هذه على المسارات الوطنية المشتركة.",
    computePool: "تعمل مساحة العمل هذه على مجمّع الحوسبة المخصص لها {{pool}}.",
    avgLatency: "متوسط زمن الاستجابة {{value}} ملّي ثانية",
    ms: "{{value}} ملّي ثانية",
    col: { name: "الاسم", workspace: "مساحة العمل", tokens: "الرموز", latency: "متوسط زمن الاستجابة", failure: "نسبة الإخفاق" },
    platformAgents: { shared: { translation: "الترجمة الآلية", bilingual: "التوليد ثنائي اللغة", dictation: "الإملاء الصوتي", agenda: "تحديد الأجندة" } },
  },
  tenants: {
    kinds: { ministry: "الوزارات", oversight: "الجهة الرقابية (الأمانة العامة لمجلس الوزراء)", platform: "المنصة" },
    statuses: { active: "نشطة", onboarding: "قيد الانضمام", suspended: "موقوفة" },
    storage: { shared: "قاعدة بيانات مشتركة", dedicated: "قاعدة بيانات مخصصة" },
    col: { workspace: "مساحة العمل", kind: "النوع", status: "الحالة", members: "الأعضاء", policies: "السياسات", domains: "نطاقات البريد", created: "تاريخ الإنشاء" },
    field: {
      kind: "نوع مساحة العمل",
      code: "الرمز",
      nameEn: "الاسم (بالإنجليزية)",
      nameAr: "الاسم (بالعربية)",
      shortNameEn: "الاسم المختصر (بالإنجليزية)",
      shortNameAr: "الاسم المختصر (بالعربية)",
      sector: "القطاع",
      accent: "اللون المميز",
      domains: "نطاقات البريد الإلكتروني",
      adminEmail: "البريد الإلكتروني للمسؤول",
      adminNameEn: "اسم المسؤول (بالإنجليزية)",
      adminNameAr: "اسم المسؤول (بالعربية)",
      storage: "التخزين",
      status: "الحالة",
      aiCeiling: "الحد الأعلى لمعالجة الذكاء الاصطناعي",
      computePool: "حوسبة الذكاء الاصطناعي",
    },
    policiesValue: "{{active}} نشطة من {{total}}",
    create: "إنشاء مساحة عمل لوزارة",
    created: "أُنشئت مساحة العمل.",
    saved: "حُفظت إعدادات الجهة.",
    statusSaved: "حُدّثت حالة الجهة.",
    search: "البحث في الجهات",
    noSector: "دون قطاع",
    settingsFor: "إعدادات {{name}}",
    settingsBody: "أسماء مساحة العمل وقطاعها وهويتها البصرية ونطاقاتها.",
    gate: "بوابة الدخول",
    gateHint: "شارك هذا الرابط مع الوزارة: يتيح تسجيل الدخول بالهوية الرقمية (UAE PASS) أو بدليل مستخدمي الوزارة، ولا يفتح إلا مساحة العمل هذه.",
    suspendFor: "إيقاف {{name}}",
    activateFor: "تفعيل {{name}}",
    suspendTitle: "هل تريد إيقاف {{name}}؟",
    activateTitle: "هل تريد تفعيل {{name}}؟",
    suspendBody: "لن يتمكن أعضاء هذه الوزارة من تسجيل الدخول إلى مساحة عملها. وتبقى السياسات والسجلات محفوظة.",
    activateBody: "سيتمكن أعضاء مساحة العمل هذه من تسجيل الدخول مجدداً.",
    suspend: "إيقاف",
    activate: "تفعيل",
    onlyMinistrySuspend: "لا يمكن إيقاف إلا مساحات عمل الوزارات.",
    classificationTitle: "إعدادات التصنيف",
    aiCeilingHint: "أعلى تصنيف تسمح مساحة العمل هذه بمعالجته بالذكاء الاصطناعي، ولا يجوز أن يتجاوز القاعدة الوطنية ({{national}})؛ التصنيف المطبّق حالياً: {{effective}}.",
    followNational: "اتباع القاعدة الوطنية",
    sharedCompute: "المسارات الوطنية المشتركة",
    computePoolHint: "يُشغّل المجمّع المخصص جميع أعمال الذكاء الاصطناعي لمساحة العمل هذه على حوسبتها الخاصة، مثل مجمّع وحدات المعالجة الرسومية لدى الوزارة أو وحدة المعالجة الرسومية لدى الأمانة العامة، فلا يُحال أي عمل إلى المسارات المشتركة، ويُعطَّل البحث في الإنترنت.",
    noComputePools: "لا توجد مجمّعات حوسبة مخصصة مُعدّة على هذه المنصة.",
    computePoolMissing: "{{pool}} (غير مُعدّ)",
    modulesTitle: "الوحدات الاختيارية",
    modules: {
      reglab: "مختبر التشريعات",
      reglabHint: "التجارب، ومسار مختبر التشريعات في دورة السياسات، ومكتب مختبر التشريعات. غير مفعّلة افتراضياً لأن الأمانة العامة لمجلس الوزراء تدير مختبر التشريعات محفظةً مستقلة. وتبقى التجارب الجارية ظاهرة في سياساتها.",
    },
    wizard: {
      title: "إنشاء مساحة عمل لوزارة",
      description: "أعدّ مساحة العمل وهويتها البصرية ومسؤولها الأول.",
      steps: { identity: "التعريف", branding: "الهوية البصرية", admin: "المسؤول", review: "المراجعة" },
      codeHint: "من حرفين إلى 16 حرفاً لاتينياً كبيراً أو رقماً، مثل MOHAP.",
      codeFormat: "استخدم من حرفين إلى 16 حرفاً لاتينياً كبيراً أو رقماً.",
      accentHint: "لون بالصيغة الست عشرية يظهر في ترويسة مساحة العمل، مثل ‎#1B6B5C.",
      accentFormat: "أدخل لوناً بالصيغة الست عشرية مثل ‎#1B6B5C.",
      domainsHint: "افصل بين النطاقات بفواصل، مثل mohap.gov.ae.",
      adminIntro: "اختياري: أضف المسؤول الأول لمساحة العمل، ويُمنح دور مسؤول مساحة العمل.",
      reviewNote: "تتبع مساحة العمل قوالب دورة السياسات الوطنية المنشورة، ويمكنك تعديل إعداداتها لاحقاً.",
      submit: "إنشاء مساحة العمل",
    },
  },
  identity: {
    tabs: { users: "المستخدمون", providers: "مزوّدو الهوية" },
    users: {
      col: { name: "المستخدم", status: "الحالة", mfa: "التحقق متعدد العوامل", lastLogin: "آخر تسجيل دخول", tenants: "مساحات العمل" },
      statuses: { active: "نشط", disabled: "معطّل" },
      mfaOn: "مفعّل",
      mfaOff: "غير مفعّل",
      never: "لم يسجّل الدخول",
      you: "أنت",
      search: "البحث بالاسم أو البريد الإلكتروني",
      emptyTitle: "لا يوجد مستخدمون مطابقون",
      emptyBody: "غيّر عبارة البحث أو مساحة العمل المختارة.",
      disable: "تعطيل",
      enable: "تفعيل",
      disableTitle: "هل تريد تعطيل {{name}}؟",
      enableTitle: "هل تريد تفعيل {{name}}؟",
      disableBody: "يُسجَّل خروج المستخدم ولن يتمكن من تسجيل الدخول إلى أي مساحة عمل.",
      enableBody: "سيتمكن المستخدم من تسجيل الدخول مجدداً بأدواره الحالية.",
      statusSaved: "حُدّثت حالة المستخدم.",
    },
    providers: {
      intro: "مزوّدو الدخول الموحد. الأسرار للكتابة فقط: لا تُعرض القيم المحفوظة مطلقاً، وترك حقل السر فارغاً يُبقي القيمة المحفوظة.",
      add: "إضافة مزوّد",
      newTitle: "مزوّد هوية جديد",
      editTitle: "تعديل {{name}}",
      dialogBody: "إعدادات الاتصال بالمزوّد. تُعامَل المفاتيح التي تتضمن «secret» أو «password» أو «key» بوصفها أسراراً.",
      saved: "حُفظ مزوّد الهوية.",
      enabled: "مفعّل",
      disabled: "معطّل",
      workspaceScoped: "لمساحة عمل واحدة",
      allWorkspaces: "جميع مساحات العمل",
      noConfig: "لا توجد إعدادات.",
      secretHidden: "محفوظ (مخفي)",
      field: { alias: "المعرّف المختصر", displayName: "الاسم المعروض (بالإنجليزية)", displayNameAr: "الاسم المعروض (بالعربية)", kind: "البروتوكول", scope: "مساحة العمل", enabled: "مفعّل لتسجيل الدخول" },
      aliasHint: "معرّف بأحرف لاتينية صغيرة يُستخدم في رابط تسجيل الدخول، مثل uaepass.",
      kinds: { oidc: "OpenID Connect", uaepass: "الهوية الرقمية (UAE PASS)", saml: "SAML", ldap: "LDAP" },
      types: { text: "نص", list: "قائمة", boolean: "نعم/لا", number: "رقم", json: "JSON" },
      rowErrors: { duplicate: "هذا المفتاح مستخدم مرتين.", number: "أدخل رقماً.", json: "أدخل صيغة JSON صحيحة." },
      config: "الإعدادات",
      configHint: "صف واحد لكل إعداد، وتُفصل عناصر القوائم بفواصل.",
      key: "المفتاح",
      type: "النوع",
      value: "القيمة",
      listHint: "قيم مفصولة بفواصل",
      secretValue: "القيمة السرية لـ {{key}}",
      secretStored: "محفوظ — اكتب لاستبداله",
      secretNew: "أدخل القيمة السرية",
      removeRow: "حذف {{key}}",
      addRow: "إضافة إعداد",
    },
  },
  roles: {
    kindFilter: "نوع مساحة العمل",
    allKinds: "جميع الأنواع",
    searchLabel: "الصلاحية",
    searchPlaceholder: "البحث في الصلاحيات",
    summary: "الأدوار: {{roles}} · الصلاحيات: {{permissions}}",
    emptyTitle: "لا توجد نتائج مطابقة",
    emptyBody: "غيّر النوع أو عبارة البحث.",
    caption: "الصلاحيات الممنوحة لكل دور",
    permission: "الصلاحية",
    granted: "ممنوحة",
    notGranted: "غير ممنوحة",
    customNote: "الأدوار مدمجة ومحددة لكل نوع من مساحات العمل، ولا تتوفر الأدوار المخصصة للجهات حالياً.",
    groups: {
      policies: "السياسات",
      records: "السجلات",
      proposals: "مقترحات الذكاء الاصطناعي",
      versions: "الإصدارات",
      comments: "التعليقات",
      gates: "البوابات",
      conformance: "المطابقة",
      agents: "الوكلاء",
      consultation: "الاستشارات",
      monitoring: "المتابعة",
      reglab: "مختبر التشريعات",
      members: "الأعضاء",
      workspace: "مساحة العمل",
      templates: "القوالب",
      oversight: "الرقابة",
      signals: "الإشارات",
      knowledge: "المعرفة",
      academy: "الأكاديمية",
      audit: "التدقيق",
      console: "وحدة إدارة المنصة",
    },
  },
  permissions: {
    policies: { read: "الاطلاع على السياسات", create: "إنشاء السياسات", edit: "تعديل السياسات", delete: "حذف السياسات", share: "مشاركة السياسات", disclose: "الإفصاح عن المحتوى المصنّف" },
    records: { edit: "تعديل سجلات المراحل" },
    proposals: { review: "مراجعة مقترحات الذكاء الاصطناعي" },
    versions: { edit: "تعديل إصدارات السياسات" },
    comments: { write: "كتابة التعليقات" },
    gates: { decide: "البت في البوابات", submit: "التقديم إلى البوابات" },
    conformance: { attest: "الإقرار بالمتطلبات", waive: "الإعفاء من المتطلبات" },
    agents: { run: "تشغيل الوكلاء" },
    consultation: { manage: "إدارة الاستشارات", respond: "الرد على الاستشارات" },
    monitoring: { edit: "تعديل المتابعة" },
    reglab: { manage: "إدارة تجارب مختبر التشريعات" },
    members: { manage: "إدارة الأعضاء" },
    workspace: { settings: "إعدادات مساحة العمل" },
    templates: { manage: "إدارة قوالب مساحة العمل" },
    oversight: { pipeline: "الاطلاع على مسار السياسات الوطني", review: "مراجعة الطلبات", decide: "البت في الطلبات", cabinet: "جدول أعمال مجلس الوزراء", registry: "إدارة السجل الوطني", overlaps: "تحليل التداخل", reglab: "الرقابة على مختبر التشريعات", analytics: "التحليلات الوطنية", governance: "إعدادات الحوكمة الوطنية" },
    signals: { read: "الاطلاع على الإشارات", manage: "إدارة الإشارات" },
    knowledge: { read: "الاطلاع على مكتبة المعرفة", manage: "إدارة مكتبة المعرفة" },
    academy: { use: "استخدام الأكاديمية", manage: "إدارة الأكاديمية" },
    audit: { read: "الاطلاع على سجل التدقيق" },
    console: { tenants: "وحدة الإدارة: الجهات", identity: "وحدة الإدارة: الهوية", roles: "وحدة الإدارة: الأدوار", workflows: "وحدة الإدارة: مسارات العمل", agents: "وحدة الإدارة: الوكلاء والتعليمات", registry: "وحدة الإدارة: السجل", aigov: "وحدة الإدارة: حوكمة الذكاء الاصطناعي", audit: "وحدة الإدارة: التدقيق", knowledge: "وحدة الإدارة: المعرفة", releases: "وحدة الإدارة: الإصدارات" },
  },
  workflows: {
    statuses: { draft: "مسودة", published: "منشور", retired: "متوقف" },
    scopes: { builtin: "مدمج", national: "وطني", workspace: "مساحة عمل" },
    tabs: { stages: "المراحل", gates: "البوابات", recordTypes: "أنواع السجلات", conformance: "المطابقة", json: "JSON" },
    phases: { phase1: "المرحلة الرئيسية الأولى · الإعداد", phase2: "المرحلة الرئيسية الثانية · الاستشارات والاعتماد", pmo: "مراجعة الأمانة العامة لمجلس الوزراء وقرار مجلس الوزراء", phase3: "المرحلة الرئيسية الثالثة · التنفيذ" },
    owners: { ministry: "الوزارة", pmo: "الأمانة العامة لمجلس الوزراء", cabinet: "مجلس الوزراء" },
    modes: { off: "معطّل", warn: "تنبيه", block: "منع" },
    col: { template: "القالب", status: "الحالة", scope: "النطاق", instruments: "أدوات السياسة", stages: "المراحل", policies: "السياسات", approved: "تاريخ الاعتماد" },
    new: "قالب جديد",
    search: "البحث في القوالب",
    back: "جميع القوالب",
    version: "الإصدار",
    versionOption: "الإصدار {{version}} · {{status}}",
    editDraft: "تعديل المسودة",
    newDraft: "مسودة إصدار جديد",
    publish: "نشر",
    publishTitle: "هل تريد نشر الإصدار {{version}} من {{name}}؟",
    publishBody: "ستستخدم الوزارات هذا الإصدار عند بدء سياسات جديدة. تتطلب القوالب الوطنية مسؤولاً ثانياً، فلا يمكنك نشر مسودة حفظتها بنفسك.",
    published: "نُشر القالب.",
    retire: "إيقاف",
    retireTitle: "هل تريد إيقاف الإصدار {{version}} من {{name}}؟",
    retireBody: "لن يكون الإصدار متاحاً للسياسات الجديدة، وتواصل السياسات التي تستخدمه العمل به.",
    retired: "أُوقف القالب.",
    fourEyes: "مبدأ الاعتماد الثنائي: يجب أن ينشر المسودة الوطنية مسؤول غير الذي حفظها.",
    issuesTitle: "ملاحظات التحقق",
    issuesCount_one: "ملاحظة واحدة",
    issuesCount_other: "عدد الملاحظات: {{count}}",
    valid: "صحيح",
    changeNote: "ملاحظة التغيير",
    pilotPhases: "مراحل التجربة",
    editor: {
      newTitle: "قالب جديد لدورة السياسات",
      newVersionTitle: "إصدار جديد من {{name}}",
      description: "عدّل مخطط دورة السياسات بصيغة JSON. تتحقق واجهة برمجة التطبيقات منه وتعرض أي ملاحظات، ويمكن حفظ المسودة مع وجود ملاحظات دون نشرها.",
      key: "المفتاح",
      keyHint: "أحرف لاتينية صغيرة وأرقام وشرطات، مثل national-default.",
      keyFormat: "استخدم أحرفاً لاتينية صغيرة وأرقاماً وشرطات (من حرفين إلى 60 حرفاً).",
      copyFrom: "البدء من",
      copyFromHint: "نسخ مخطط قالب قائم.",
      blank: "مخطط فارغ",
      nameEn: "الاسم (بالإنجليزية)",
      nameAr: "الاسم (بالعربية)",
      descriptionEn: "الوصف (بالإنجليزية)",
      descriptionAr: "الوصف (بالعربية)",
      instruments: "أنواع أدوات السياسة",
      changeNote: "ملاحظة التغيير",
      changeNoteHint: "ما الذي تغيّر في هذا الإصدار، لاطلاع المعتمِد.",
      graph: "مخطط دورة السياسات",
      saveDraft: "حفظ المسودة",
      savedWithIssues: "حُفظت مسودة الإصدار {{version}} مع وجود ملاحظات",
      openDraft: "فتح المسودة",
    },
    graph: {
      stage: "المرحلة",
      phase: "المرحلة الرئيسية",
      owner: "الجهة المسؤولة",
      sla: "المدة المحددة",
      calendarDays_one: "يوم تقويمي واحد",
      calendarDays_other: "أيام تقويمية: {{count}}",
      workingDays_one: "يوم عمل واحد",
      workingDays_other: "أيام عمل: {{count}}",
      leadAgent: "الوكيل الرئيسي",
      recordTypes: "أنواع السجلات",
      gate: "البوابة",
      approvers: "المعتمِدون",
      outcomes: "النتائج",
      requiredRecords: "السجلات المطلوبة",
      checks: "الفحوص",
      stepUp: "تحقق إضافي",
      bilingual: "ثنائي اللغة",
      noPending: "لا مقترحات معلّقة",
      minConfidence: "درجة الثقة ≥ {{value}}",
      effects: "الآثار",
      noRecordTypes: "لا توجد أنواع سجلات في هذا القالب.",
      required: "مطلوب",
      noConformance: "لا توجد بوابة تقيّم المطابقة.",
    },
  },
  agents: {
    col: { agent: "الوكيل", team: "الفريق", tier: "فئة الذكاء الاصطناعي", maxClass: "الحد الأعلى للتصنيف", status: "الحالة", runs: "التشغيلات (30 يوماً)", acceptance: "نسبة القبول" },
    tiers: { Reasoning: "الاستدلال", Fast: "السريع", Arabic: "العربية", Vision: "الرؤية" },
    teams: { orchestrator: "التنسيق", phase1: "المرحلة الرئيسية الأولى · الوزارة", phase2: "المرحلة الرئيسية الثانية · الوزارة", pmo: "الأمانة العامة لمجلس الوزراء", phase3: "المرحلة الرئيسية الثالثة · المتابعة", shared: "مشترك" },
    allStages: "جميع المراحل",
    moreStages: "+{{count}} أخرى",
    teamNumber: "{{team}} · الوكيل {{number}}",
    on: "مفعّل",
    off: "معطّل",
    enabled: "مفعّل",
    configure: "إعداد {{name}}",
    search: "البحث في الوكلاء",
    stages: "المراحل",
    tools: "الأدوات",
    tierHint: "فئة قدرات الذكاء الاصطناعي التي يعمل عليها الوكيل.",
    maxClassHint: "أعلى تصنيف للبيانات يُسمح للوكيل بالاطلاع عليه.",
    prompt: "التعليمات",
    reviewLocked: "المراجعة البشرية مطلوبة دائماً",
    reviewLockedBody: "تبقى مخرجات الوكيل مقترحاً إلى أن يقبلها موظف مختص، ولا يمكن تعطيل ذلك.",
    saved: "حُفظ الوكيل.",
  },
  prompts: {
    search: "البحث في التعليمات",
    active: "مفعّل",
    activeVersion: "الإصدار {{version}} · {{date}}",
    versionLabel: "الإصدار {{version}}",
    newVersion: "إصدار جديد",
    newTitle: "إصدار جديد من {{key}}",
    newBody: "يُحفظ الإصدار الجديد غير مفعّل ما لم تفعّله الآن.",
    contentEn: "التعليمات (بالإنجليزية)",
    contentAr: "التعليمات (بالعربية)",
    changeNote: "ملاحظة التغيير",
    changeNoteHint: "ما الذي تغيّر ولماذا، لاطلاع المراجِع.",
    activateNow: "تفعيل هذا الإصدار الآن",
    activationNeedsGovernance: "يتطلب التفعيل اعتماد حوكمة الذكاء الاصطناعي، ويُحفظ الإصدار غير مفعّل.",
    saveVersion: "حفظ الإصدار",
    created: "حُفظ إصدار التعليمات.",
    activate: "تفعيل",
    activateTitle: "هل تريد تفعيل الإصدار {{version}} من {{key}}؟",
    activateBody: "سيستخدم الوكلاء هذا الإصدار ابتداءً من تشغيلهم التالي.",
    activated: "فُعّل إصدار التعليمات.",
    approvedAt: "اعتُمد {{time}}",
    notApproved: "لم يُعتمد بعد",
    tabs: { text: "النص", diff: "المقارنة" },
    from: "من",
    to: "إلى",
  },
  toolkit: {
    pack: "حزمة السجل",
    version: "الإصدار",
    requirements: "المتطلبات",
    recordTypes: "أنواع السجلات",
    families: "مجموعات المتطلبات",
    templates: "قوالب الوثائق",
    sha: "المجموع الاختباري للحزمة (SHA-256)",
    search: "البحث في أنواع السجلات",
    col: { type: "نوع السجل", module: "الوحدة", fields: "الحقول", required: "الحقول المطلوبة" },
    field: "الحقل",
    kind: "النوع",
    constraints: "القيود",
  },
  templates: {
    sections_one: "قسم واحد",
    sections_other: "عدد الأقسام: {{count}}",
    tabular: "جدول",
  },
  conformance: {
    framework: "الإطار",
    allFrameworks: "جميع الأطر",
    frameworks: { uae_cabinet_guidebook: "دليل إعداد السياسات العامة", uae_reglab: "مختبر التشريعات" },
    stages: {
      principles: "المبادئ",
      rationale: "المبررات",
      options_impacts: "الخيارات والآثار",
      consultation: "الاستشارات",
      implementation: "التنفيذ",
      evaluation: "التقييم",
      reglab_general: "مختبر التشريعات · عام",
      reglab_application: "مختبر التشريعات · تقديم الطلب",
      reglab_permit: "مختبر التشريعات · الترخيص",
      reglab_testing: "مختبر التشريعات · الاختبار",
      reglab_impact: "مختبر التشريعات · الأثر",
      reglab_review: "مختبر التشريعات · المراجعة",
    },
    gates: {
      submission: "التقديم",
      publication: "النشر",
      in_force: "بدء النفاذ",
      none: "دون بوابة",
      pilot_permit: "التجربة · الترخيص",
      pilot_testing_reporting: "التجربة · الاختبار ورفع التقارير",
      pilot_impact_assessment: "التجربة · تقييم الأثر",
      pilot_review: "التجربة · المراجعة",
      pilot_decision: "التجربة · القرار",
    },
    levels: { mandatory: "إلزامي", recommended: "موصى به" },
    arSources: { official: "صياغة عربية رسمية", decoded_unverified: "صياغة عربية بانتظار الاعتماد" },
    col: { id: "المرجع", wording: "المتطلب", family: "المجموعة", stage: "المرحلة", gate: "البوابة", level: "المستوى", arabic: "الصياغة العربية" },
    search: "البحث في المتطلبات",
    emptyTitle: "لا توجد متطلبات مطابقة",
    emptyBody: "غيّر عوامل التصفية أو عبارة البحث.",
    attestation: "يتطلب إقراراً",
    automated: "فحص آلي",
    wordingEn: "الصياغة الإنجليزية",
    wordingAr: "الصياغة العربية",
    anchors: "موضع التقييم",
    source: "المصدر",
    openSource: "فتح الوثيقة المصدر",
    page: "الدليل، صفحة {{page}}",
    signoff: {
      statuses: { official: "صياغة عربية رسمية", pending: "بانتظار اعتماد الأمانة العامة لمجلس الوزراء", approved: "معتمدة من الأمانة العامة لمجلس الوزراء", changes_requested: "مطلوب تعديلها" },
      summary: "الصياغة العربية المستخرجة من الدليل: {{approved}} من {{total}} معتمدة، و{{pending}} بانتظار الاعتماد، و{{changes}} مطلوب تعديلها.",
      summaryHint: "لا يترتب على متطلبات الدليل سوى التنبيه عند بواباتها إلى أن تعتمد الأمانة العامة لمجلس الوزراء صياغتها العربية، وبعد الاعتماد يمنع المتطلب غير المستوفى اجتياز بوابته.",
      title: "اعتماد الأمانة العامة لمجلس الوزراء للصياغة العربية",
      explain: "قارن الصياغة العربية بالنسخة العربية من الدليل. أي تعديل لاحق على الصياغة يستلزم اعتماداً جديداً.",
      correctedAr: "الصياغة العربية المصححة (اختياري)",
      correctedArHint: "اترك الحقل فارغاً لاعتماد الصياغة كما هي. تحل الصياغة المصححة محلها في جميع السياسات.",
      note: "ملاحظة",
      noteHint: "مطلوبة عند طلب التعديل: وضّح التعديل المطلوب.",
      approve: "اعتماد",
      requestChanges: "طلب تعديل",
      saved: "حُفظ الاعتماد",
      by: "{{name}}، {{date}}",
      approveFamily: "اعتماد الصياغات المعلّقة في هذه المجموعة ({{count}})",
      approveFamilyTitle: "هل تريد اعتماد الصياغات العربية ({{count}})؟",
      approveFamilyBody: "ستُعتمد كما هي الصياغة العربية لكل متطلب بانتظار الاعتماد في {{family}}، وبعدها يمنع كل متطلب غير مستوفى اجتياز بوابته.",
      approvedCount: "عدد الصياغات التي اعتُمدت: {{count}}",
      pmoOnly: "يقتصر اعتماد الصياغة العربية للدليل على مستخدمي الأمانة العامة لمجلس الوزراء.",
      correctedShown: "الصياغة العربية المصححة مطبّقة",
    },
  },
  knowledge: {
    tabs: { documents: "الوثائق", search: "اختبار الاسترجاع", glossary: "المسرد" },
    split: "{{national}} وطنية · {{workspace}} لمساحات العمل",
    col: { title: "الوثيقة", collection: "المجموعة", kind: "النوع", scope: "النطاق", classification: "التصنيف", chunks: "المقاطع", added: "تاريخ الإضافة" },
    national: "وطنية",
    workspace: "مساحة عمل",
    allCollections: "جميع المجموعات",
    searchDocs: "البحث في الوثائق",
    emptyDocs: "لا توجد وثائق",
    emptyDocsBody: "غيّر عوامل التصفية أو ارفع وثيقة.",
    legalStatus: "الوضع القانوني",
    openSource: "فتح المصدر",
    chunks_one: "مقطع مفهرس واحد",
    chunks_other: "عدد المقاطع المفهرسة: {{count}}",
    noChunks: "لم تُفهرس بعد",
    noChunksBody: "تظهر المقاطع بعد اكتمال الفهرسة.",
    deactivate: "إزالة من المكتبة",
    deactivateTitle: "هل تريد إزالة هذه الوثيقة؟",
    deactivateBody: "لن يُبحث في «{{title}}» ولن يستشهد بها الوكلاء، وتبقى الاستشهادات السابقة محفوظة.",
    deactivated: "أُزيلت الوثيقة من المكتبة.",
    searchPlaceholder: "اطرح سؤالاً أو أدخل كلمات مفتاحية",
    run: "بحث",
    searchIntro: "اختبار الاسترجاع",
    searchIntroBody: "يُجري البحث الهجين نفسه الذي يستخدمه الوكلاء، ويعرض المقاطع ودرجاتها كما تصلهم.",
    noHits: "لم يُعثر على مقاطع",
    noHitsBody: "جرّب كلمات أخرى أو مجموعة أخرى.",
    results: "نتائج البحث",
    score: "الدرجة {{score}}",
    searchGlossary: "البحث في المصطلحات",
    emptyGlossary: "لا توجد مصطلحات",
    emptyGlossaryBody: "لا يطابق أي مصطلح عبارة البحث.",
    upload: "رفع وثيقة",
    uploadTitle: "رفع وثيقة",
    uploadBody: "تُحفظ الوثيقة وتُفهرس في الخلفية، ثم تصبح متاحة للوكلاء.",
    fileHint: "PDF أو Word أو نص أو Markdown أو HTML.",
    uploaded: "رُفعت الوثيقة وبدأت فهرستها.",
    publishNational: "النشر في المكتبة الوطنية (متاحة لجميع مساحات العمل)",
    field: {
      file: "الملف",
      titleEn: "العنوان (بالإنجليزية)",
      titleAr: "العنوان (بالعربية)",
      issuer: "جهة الإصدار",
      number: "الرقم",
      year: "السنة",
      sourceUrl: "رابط المصدر",
      summaryEn: "الملخص (بالإنجليزية)",
      summaryAr: "الملخص (بالعربية)",
      sectors: "القطاعات",
    },
  },
  aigov: {
    tabs: { usage: "الاستخدام والتكلفة", guardrails: "الضوابط", evals: "التقييمات", ledger: "سجل المراجعة" },
    severity: { Info: "معلومة", Warning: "تحذير", Blocked: "محظور" },
    metrics: { accuracy: "الدقة", citationFaithfulness: "أمانة الاستشهاد", schemaValidity: "صحة البنية", arabicQuality: "جودة العربية" },
    col: { at: "الوقت", severity: "الخطورة", agent: "الوكيل", rule: "القاعدة", detail: "التفاصيل", action: "الإجراء المتخذ", tenant: "مساحة العمل", prompt: "إصدار التعليمات", cases: "الحالات", drift: "الانحراف", trigger: "المُحفّز" },
    allSeverities: "جميع مستويات الخطورة",
    allAgents: "جميع الوكلاء",
    emptyGuardrails: "لا توجد أحداث ضوابط",
    emptyGuardrailsBody: "لم يُفعَّل أي ضابط خلال هذه الفترة.",
    emptyEvals: "لا توجد تشغيلات تقييم",
    emptyEvalsBody: "تظهر تشغيلات التقييم بعد تقييم أي تغيير على وكيل أو تعليمات.",
    drift: "انحراف",
    stable: "مستقر",
    trend: "اتجاه التقييم · {{agent}} (%)",
    emptyLedger: "لا توجد مراجعات في هذه الفترة",
    emptyLedgerBody: "يسجّل السجل كيفية تعامل الموظفين مع كل مقترح من مقترحات الذكاء الاصطناعي.",
    ledger: {
      title: "المراجعة البشرية لمخرجات الذكاء الاصطناعي",
      body: "كيفية تعامل الموظفين مع مقترحات كل وكيل.",
      accepted: "مقبولة",
      edited: "معدّلة",
      rejected: "مرفوضة",
      rate: "نسبة القبول",
      editDistance: "متوسط مسافة التعديل",
    },
  },
  audit: {
    export: "تصدير بصيغة CSV",
    filters: "عوامل تصفية التدقيق",
    search: "البحث في الملخص أو المنفّذ أو العنصر",
    from: "من تاريخ",
    to: "إلى تاريخ",
    allTenants: "جميع مساحات العمل",
    clear: "مسح عوامل التصفية",
    platform: "المنصة",
    col: { at: "الوقت", tenant: "مساحة العمل", actor: "المنفّذ", action: "الإجراء", entity: "العنصر", summary: "الملخص" },
    actorKinds: { human: "شخص", agent: "وكيل ذكاء اصطناعي", system: "النظام" },
    classification: "التصنيف",
    ip: "عنوان IP",
    correlation: "معرّف الارتباط",
    hash: "بصمة الحدث",
    verifyTitle: "التحقق من سلسلة التجزئة",
    verifyBody: "يعيد حساب سلسلة التجزئة لسجل تدقيق كل مساحة عمل لإثبات عدم تعديل أي حدث أو حذفه.",
    verify: "التحقق من السلاسل",
    reverify: "إعادة التحقق",
    intact: "سليمة",
    broken: "منقطعة",
    intactTitle: "جميع السلاسل سليمة",
    intactBody_one: "جرى التحقق من سلسلة واحدة.",
    intactBody_other: "عدد السلاسل التي جرى التحقق منها: {{count}}.",
    brokenTitle_one: "توجد سلسلة منقطعة",
    brokenTitle_other: "عدد السلاسل المنقطعة: {{count}}",
    brokenBody: "لم يعد أحد الأحداث مطابقاً لبصمته. يُرجى الحفاظ على قاعدة البيانات كما هي والإبلاغ عن حادث أمني.",
    brokenAt: "الانقطاع عند الحدث {{id}}",
    events_one: "حدث واحد",
    events_other: "عدد الأحداث: {{count}}",
  },
  releases: {
    noHistoryTitle: "سجل الإصدارات غير متاح بعد",
    noHistoryBody: "لا تتضمن واجهة برمجة التطبيقات نقطة وصول للإصدارات أو عمليات النشر، وتعرض هذه الصفحة ما يعمل حالياً.",
    console: "وحدة إدارة المنصة",
    consoleBody: "إصدار وحدة الإدارة الحالي.",
    builtAt: "تاريخ البناء",
    mode: "الوضع",
    modes: { development: "تطوير", production: "إنتاج", test: "اختبار" },
    api: "واجهة برمجة التطبيقات",
    checkedAt: "آخر فحص {{at}}",
    pack: "حزمة السجل",
    database: "قاعدة البيانات",
  },
};

export default ar;
